import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af21dac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absent-students-list" }

import lateIcon from '@/assets/icons/emojis/late.png';
import calendarIcon from '@/assets/icons/emojis/calendar.png';
import messageCalloutIcon from '@/assets/icons/emojis/messageCallout.png';
import UniversalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import { StudentStatus } from '@/http/pageModels/teacherModels/classPage/AbsentStudentsResponseModel';
import { AbsentStudentsService } from '@/http/services/TeacherServices/ClassPageServices/AbsentStudentsService';
import router from '@/router';
import { onMounted, reactive } from 'vue';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'AbsentStudentsSubpage',
  setup(__props) {

const state = reactive<{ data: StudentStatus[] }>({
    data: [],
});

onMounted(() => {
    const classId = router.currentRoute.value.params.classId;
    AbsentStudentsService.getAbsentStudents(+classId).then((response) => {
        state.data = AbsentStudentsService.handleClassAbsentStudents(
            +classId,
            response.data
        );
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data, (studentStatus) => {
      return (_openBlock(), _createBlock(UniversalCard, {
        key: studentStatus.studentId,
        props: {
                type: 'outlined',
                content: studentStatus.studentFullName,
                dataTags: [
                    {
                        iconCompleteUrl: _unref(lateIcon),
                        title: studentStatus.statusName,
                        color: 'var(--snotra--sys--surface-variant)',
                    },
                    {
                        iconCompleteUrl: _unref(calendarIcon),
                        title: `Статус установлен: ${_unref(moment)(
                            studentStatus.dateOfAppend
                        ).format('DD.MM.YYYY')}`,
                        color: 'var(--snotra--sys--surface-variant)',
                    },
                    {
                        iconCompleteUrl: _unref(messageCalloutIcon),
                        title: `Сообщение: ${studentStatus.comment}`,
                        color: 'var(--snotra--sys--surface-variant)',
                    },
                ],
            }
      }, null, 8, ["props"]))
    }), 128))
  ]))
}
}

})